import { Component, OnInit, ViewChild, TemplateRef, OnDestroy} from '@angular/core';
import { PhoneReportsService } from '../services/phone-reports.service';
import { Observable, Subscription, Subject } from 'rxjs';
import { interval } from 'rxjs/observable/interval';
import { map, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-phone-reports',
  templateUrl: './phone-reports.component.html',
  styleUrls: ['./phone-reports.component.scss']
})
export class PhoneReportsComponent implements OnInit, OnDestroy {
  @ViewChild( 'titlePage' ) titlePage: TemplateRef<any>;
  title = 'PHONE_REPORTS';

  private destroy$ = new Subject<boolean>();

  isStartQueryServer = false;
  isColor = 'primary'

  private count = 0;
  private timer: Observable<number>;
  private ticker: Subscription;
  status: number = 0;

  constructor(
    public phoneReports: PhoneReportsService,
  ) { }

  ngOnInit() {
    this.timer =  interval(5000).pipe(
      map((t) => this.count += 1)
    );

    this.phoneReports.getTestStatusTrack()
        .pipe(takeUntil(this.destroy$))
        .subscribe((status: number) => {
          if (status < 100) {
            this.status = status;
          } else {
            this.isStartQueryServer = !this.isStartQueryServer;
            this.isColor = 'primary';
            this.ticker.unsubscribe();
            this.phoneReports.getAllReports();
          }
        });
   
  }

  onServerSurvey() {
    this.isStartQueryServer = !this.isStartQueryServer;
    if (!this.isStartQueryServer) {
      this.phoneReports.getStopTest().subscribe(res => {
        this.isColor = 'primary';
        this.ticker.unsubscribe();
        this.phoneReports.getAllReports();
        this.status = 0;
      });
    } else {
      this.phoneReports.getStartTest().subscribe(res => {
        this.isColor = 'warn';
        this.ticker = this.timer.subscribe(t => {
          this.count = t;
          this.phoneReports.getTestStatus();          
        });
      });
    }
  }
  
  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/phone-reports/phone-reports/phone-reports.component.ts